import { Autocomplete, Button, Grid, TextField } from '@mui/material';
import styles from './styles.module.css'
import InputMask from "react-input-mask";
import banksData from '../../../services/banks.json'
import { useState } from 'react';
import ModalDadosBancarios from './ModalDadosBancarios';

const DadosBancarios = ({ handleStep,
  dataForm,
  setDataForm,
  setMsg,
  setOpenSnackbarErro,
  setError,
  handleError,
  handleHelperText,
  title
}) => {
  const [openModal, setOpenModal] = useState(false)
  const [dadosBancariosSecundario, setDadosBancariosSecundario] = useState()

  const bankNames = banksData
    .map((bank) => `${bank.code} - ${bank.name}`)
    .sort((a, b) => {
      const codeA = parseInt(a.split(" - ")[0]);
      const codeB = parseInt(b.split(" - ")[0]);
      return codeA - codeB;
    });

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleNext = (e) => {
    e.preventDefault()
    const form = e.target;

    if (form.checkValidity()) {
      if (title !== 'Cliente') {
        setOpenModal(true)
        return
      }
      handleStep(6)
    } else {
      setError(true)
    }
  }

  const handleBack = () => {
    handleStep(4)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setDataForm({ ...dataForm, dadosBancarios: { ...dataForm.dadosBancarios, [name]: value } })
  }

  const handleChangeAutoComplete = (name, value) => {
    setDataForm({ ...dataForm, dadosBancarios: { ...dataForm.dadosBancarios, [name]: value } })
  }

  return (
    <>
      <form className={styles.form_container} onSubmit={handleNext} noValidate>
        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              fullWidth
              size="small"
              value={dataForm.dadosBancarios.banco}
              options={bankNames}
              onChange={(_, value) => handleChangeAutoComplete('banco', value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Banco"
                  error={handleError('dadosBancarios', 'banco')}
                  helperText={handleHelperText('dadosBancarios', 'banco')}
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <InputMask
              mask="9999"
              maskChar={null}
              onChange={handleChange}
              value={dataForm.dadosBancarios.agencia}
            >
              {() => (
                <TextField
                  size="small"
                  label="Agência"
                  name='agencia'
                  error={handleError('dadosBancarios', 'agencia')}
                  helperText={handleHelperText('dadosBancarios', 'agencia')}
                  fullWidth
                  required
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputMask
              mask="999999999999"
              maskChar={null}
              onChange={handleChange}
              value={dataForm.dadosBancarios.conta}
            >
              {() => (
                <TextField
                  size="small"
                  label="Conta"
                  name='conta'
                  error={handleError('dadosBancarios', 'conta')}
                  helperText={handleHelperText('dadosBancarios', 'conta')}
                  fullWidth
                  required
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="PIX"
              name='pix'
              onChange={handleChange}
              value={dataForm.dadosBancarios.pix}
              fullWidth
            />
          </Grid>
        </Grid>
        <div className={styles.container_button}>
          <Button
            className={styles.button_back}
            onClick={handleBack}
          >
            Voltar
          </Button>
          <Button
            className={styles.button_next}
            type='submit'
          >
            Avançar
          </Button>
        </div>
      </form>
      <ModalDadosBancarios
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        setActiveStep={handleStep}
        bankNames={bankNames}
        dadosBancariosSecundario={dadosBancariosSecundario}
        setDadosBancariosSecundario={setDadosBancariosSecundario}
        dataForm={dataForm}
        setDataForm={setDataForm}
      />
    </>
  )
}

export default DadosBancarios